import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

import Loading from "../../app/universalComponents/Loading";
import Sidebar from "./sidebar/Sidebar";
import EditEventInfoForm from "../create-edit/EventInfoForm";
import { useEventsList, useOrganiser } from "./dashboardApi";

export default function DashboardPage() {
  const {
    data: organiser,
    isPending: organiserPending,
    error: organiserError,
  } = useOrganiser();

  const {
    data: eventsList = [],
    isPending: eventsPending,
    error: eventsError,
  } = useEventsList();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  useEffect(() => {
    document.title = "Dashboard | Tickets.NP";
  }, []);

  if (organiserPending || eventsPending) {
    return <Loading fullPage />;
  }

  if (organiserError ?? eventsError) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p>{organiserError?.message ?? eventsError?.message}</p>
      </div>
    );
  }

  function handleCreateEvent() {
    setIsSidebarOpen(false);
    setIsCreateOpen(true);
  }

  function handleCloseSidebar() {
    setIsSidebarOpen(false);
  }

  return (
    <div className="flex h-screen">
      <aside className="hidden w-60 shrink-0 flex-col border-r md:flex">
        <Sidebar
          organiser={organiser}
          eventsList={eventsList}
          onCreateEvent={handleCreateEvent}
        />
      </aside>

      {isSidebarOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={handleCloseSidebar}
          className="fixed inset-0 z-30 bg-black/30 md:hidden"
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-60 flex-col border-r bg-white shadow-xl transition-transform duration-300 ease-in-out md:hidden ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <Sidebar
          organiser={organiser}
          eventsList={eventsList}
          onNavigate={handleCloseSidebar}
          onCreateEvent={handleCreateEvent}
        />

        <button
          type="button"
          aria-label="Close sidebar"
          onClick={handleCloseSidebar}
          className="absolute left-full top-1/2 flex h-14 w-7 -translate-y-1/2 items-center justify-center rounded-r-sm bg-black shadow-md"
        >
          <ChevronLeftIcon className="h-5 w-5 text-white" />
        </button>
      </aside>

      {!isSidebarOpen && (
        <button
          type="button"
          aria-label="Open sidebar"
          onClick={() => setIsSidebarOpen(true)}
          className="fixed left-0 top-1/2 z-40 flex h-14 w-7 -translate-y-1/2 items-center justify-center rounded-r-sm bg-black shadow-md md:hidden"
        >
          <ChevronRightIcon className="h-5 w-5 text-white" />
        </button>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <Outlet context={{ organiser, eventsList }} />
      </div>

      {isCreateOpen && (
        <EditEventInfoForm
          mode="create"
          onClose={() => setIsCreateOpen(false)}
        />
      )}
    </div>
  );
}